import { useQuery, gql } from "@apollo/client";

const query = gql`
  query luke {
    StudyPrograms
      @rest(
        type: "StudyProgram"
        path: "/wp-json/wp/v2/studieretning?per_page=100"
      ) {
      id
      title
      link
      acf
    }
  }
`;

export const useStudyPrograms = () => {
  const { data, loading } = useQuery(query);

  return {
    loading,
    data: data?.StudyPrograms,
  };
};
